<template>
  <section id="welcomeDepositBonus">
    <BottomLine class="title-wrapper">
      <h2 class="title">{{ $t('menu.welcomeBonus') }}</h2>
    </BottomLine>
    <div class="btn-wrapper">
      <Button @click="activedTab = CONDITION_TAB" v-bind="getStyle(activedTab === CONDITION_TAB)">
        {{ $t('common.campaignCondition') }}
      </Button>
      <Button @click="activedTab = OVERVIEW_TAB" v-bind="getStyle(activedTab === OVERVIEW_TAB)">
        {{ $t('common.statusOverview') }}
      </Button>
    </div>
    <component :is="currentComponent" v-bind="{ accountInfo, campaignId }" v-on="{ change: getWelcomeBonusInfo }" />
  </section>
</template>

<script>
import BottomLine from '@/components/decorator/BottomLine.vue';
import Button from '@/components/interact/Button.vue';
import CampaignConditions from '@/components/cnDepositBonus/welcomeBonus/CampaignConditions.vue';
import StatusOverview from '@/components/cnDepositBonus/welcomeBonus/StatusOverview.vue';
import { btnStyleConfig } from '@/constants/style';
import { apiCampaignInfo } from '@/resource';

const CONDITION_TAB = 'condition-tab';
const OVERVIEW_TAB = 'overview-tab';

export default {
  name: 'WelcomeBonus',
  components: {
    BottomLine,
    Button,
    CampaignConditions,
    StatusOverview
  },
  data() {
    return {
      CONDITION_TAB,
      OVERVIEW_TAB,
      activedTab: CONDITION_TAB,
      btnStyleConfig,
      accountInfo: null
    };
  },
  computed: {
    currentComponent() {
      return this.activedTab === CONDITION_TAB ? 'CampaignConditions' : 'StatusOverview';
    },
    campaignId() {
      let campaign = this.$store.state.promotion.eligibleCampaigns.find(c => c.campaignType === 'WELCOME_BONUS');
      return campaign ? campaign.id : null;
    }
  },
  mounted() {
    this.getWelcomeBonusInfo();
  },
  methods: {
    getStyle(active) {
      if (active) return btnStyleConfig.BTN_ACTIVE;
      return btnStyleConfig.BTN_DEFAULT;
    },
    getWelcomeBonusInfo() {
      apiCampaignInfo(this.campaignId)
        .then(resp => {
          if (resp.data.code === 0) {
            this.accountInfo = resp.data.data;
          }
        })
        .catch(e => {
          console.log(e);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
#welcomeDepositBonus {
  text-align: center;
  position: relative;
  display: flex;
  flex-direction: column;
  & .title-wrapper {
    margin-top: 59px;
  }

  & .title {
    font-size: 56px;
    font-family: Oblivian, PingFangSC-Medium;
    font-weight: 500;
    color: #000d28;

    @media (max-width: $DEVICE_SIZE_MOBILEL) {
      font-size: 44px;
    }
  }

  & .btn-wrapper {
    margin: auto;
    margin-top: 60px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    column-gap: 50px;
  }

  @media (max-width: $DEVICE_SIZE_MOBILEL) {
    padding: 0 5px;
  }
}
</style>
